export default "__VITE_ASSET__eb3d4fcc__"